import { Group, Text, ThemeIcon, Tooltip } from '@mantine/core';
import { PriorityTypes } from 'utils/constants';

/**
 * Read only priority display, matching the priority select in the Style Edit.
 *
 * @param {string} value - the priority value e.g. 'P0'
 * @param {Array|Object} types - priority lookup to resolve the value against (defaults to PriorityTypes)
 * @param {boolean} showLabel - show the label next to the icon
 * @param {string} size - mantine size for the icon and text
 */
const PriorityBadge = ({ value, types = PriorityTypes, showLabel = true, size = 'sm' }) => {
    if (!value) return null;

    const options = Array.isArray(types) ? types : Object.values(types);
    const priority = options.find((p) => p.value === value);

    if (!priority) return <Text size={size}>{value}</Text>;

    const display = (
        <Group noWrap spacing='xs'>
            <ThemeIcon size={size} variant='light' color={priority.color}>
                {priority.icon}
            </ThemeIcon>
            {showLabel ? <Text size={size}>{priority.label}</Text> : null}
        </Group>
    );

    const tooltip = priority.description ?? (showLabel ? null : priority.label);

    return tooltip ? (
        <Tooltip label={tooltip} withinPortal>
            <div style={{ display: 'inline-block' }}>{display}</div>
        </Tooltip>
    ) : (
        display
    );
};

export default PriorityBadge;
